<div
  class="loader rounded-full border-4 border-t-4 border-grey-200 ease-linear"
  role="progressbar"
  [ngClass]="{'size-4': size === 'xs', 'size-6': size === 'sm', 'size-12': size === 'md'}"
></div>
